// getters
export const GET_TRACK_DATA = 'tt/GET_TRACK_DATA'
export const GET_INIT_TIME_Z_LIST = 'tt/GET_INIT_TIME_Z_LIST'
export const GET_SRC_INFO_LIST = 'tt/GET_SRC_INFO_LIST'
export const GET_TC_INFO_LIST = 'tt/GET_TC_INFO_LIST'
export const GET_OPTIONS = 'tt/GET_OPTIONS'
export const GET_DTG = 'tt/GET_DTG'
export const GET_STOP_DTG = 'tt/GET_STOP_DTG'
export const GET_MAP_OPTIONS = 'tt/GET_MAP_OPTIONS'
export const GET_HOURLY_POINTS = 'tt/GET_HOURLY_POINTS'
export const GET_LOADING_STATE = 'tt/GET_LOADING_STATE'
export const GET_SELECTED_WIND_SOURCE = 'tt/GET_SELECTED_WIND_SOURCE'
export const GET_WIND_URI = 'tt/GET_WIND_URI'
export const GET_FOCUSED_TC = 'tt/GET_FOCUSED_TC'
export const GET_SATELLITE_DATA_SET = 'tt/GET_SATELLITE_DATA_SET'
export const GET_TYPHOON_PROBABILITY = 'tt/GET_TYPHOON_PROBABILITY'
export const GET_SATELLITE_LATEST_TIME = 'tt/GET_SATELLITE_LATEST_TIME'

// mutations
export const MUTATIONS_DATA = 'tt/MUTATIONS_DATA'
export const MUTATIONS_INIT_TIME_Z_LIST = 'tt/MUTATIONS_INIT_TIME_Z_LIST'
export const MUTATIONS_OPTIONS = 'tt/MUTATIONS_OPTIONS'
export const MUTATIONS_DTG = 'tt/MUTATIONS_DTG'
export const MUTATIONS_STOP_DTG = 'tt/MUTATIONS_STOP_DTG'
export const MUTATIONS_MAP_OPTIONS = 'tt/MUTATIONS_MAP_OPTIONS'
export const MUTATIONS_TRIGGER_LOADING = 'tt/MUTATIONS_TRIGGER_LOADING'
export const MUTATIONS_COMPLETE_LOADING = 'tt/MUTATIONS_COMPLETE_LOADING'
export const MUTATIONS_WIND_FILES = 'tt/MUTATIONS_WIND_FILES'
export const MUTATIONS_SELECTED_WIND_URI = 'tt/MUTATIONS_SELECTED_WIND_URI'
export const MUTATIONS_CLEAR_HOURLY_POINTS = 'tt/MUTATIONS_CLEAR_HOURLY_POINTS'
export const MUTATIONS_SATELLITE_DATA_SET = 'tt/MUTATIONS_SATELLITE_DATA_SET'
export const MUTATIONS_TYPHOON_PROBABILITY = 'tt/MUTATIONS_TYPHOON_PROBABILITY'
export const MUTATIONS_SELECTED_SATELLITE_DATA = 'tt/MUTATIONS_SELECTED_SATELLITE_DATA'
export const MUTATIONS_SATELLITE_LATEST_TIME = 'tt/MUTATIONS_SATELLITE_LATEST_TIME'

// actions
export const SET_DTG = 'tt/SET_DTG'
export const SET_STOP_DTG = 'tt/SET_STOP_DTG'
export const SET_MAP_OPTIONS = 'tt/SET_MAP_OPTIONS'
export const SET_OPTIONS = 'tt/SET_OPTIONS'
export const RESET_WIND = 'tt/RESET_WIND'
export const RESET_SATELLITE_DATA = 'tt/RESET_SATELLITE_DATA'

export const FETCH_TRACK_DATA = 'tt/FETCH_TRACK_DATA'
export const FETCH_OPTIONS = 'tt/FETCH_OPTIONS'
export const FETCH_SRC_INFOS = 'tt/FETCH_SRC_INFOS'
export const FETCH_INIT_TIME_Z_LIST = 'tt/FETCH_INIT_TIME_Z_LIST'
export const FETCH_MAP_OPTIONS = 'tt/FETCH_MAP_OPTIONS'
export const FETCH_WIND_FILE = 'tt/FETCH_WIND_FILE'
export const FETCH_SATELLITE_DATA = 'tt/FETCH_SATELLITE_DATA'
export const FETCH_TYPHOON_PROBABILITY = 'tt/FETCH_TYPHOON_PROBABILITY'
export const FETCH_SATELLITE_LATEST_TIME = 'tt/FETCH_SATELLITE_LATEST_TIME'

export const INITIALIZE = 'tt/INITIALIZE'



// WEBPACK FOOTER //
// ./src/store/types.js